// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Шаблони документів» (Document templates, ключ `doctpl`, група `documents`). */
export const documentTemplatesManifest: IModuleManifest = {
  key: 'doctpl',
  group: 'documents',
  slug: 'document-templates',
  prefix: 'DTM',
  name: { en: 'Document templates', uk: 'Шаблони документів' },
  entities: [
    { key: 'doctpl', slug: 'doctpl', name: { en: 'Document templates', uk: 'Шаблони документів' }, main: true },
  ],
  loadState: () => import('./state/documentTemplatesSlice').then((m) => m.documentTemplatesSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
